export default __webpack_public_path__ + "static/media/xdn.1d79075c.svg";